<template>
<v-layout row class="align-center layout pl-0 pt-0 app--page-header">
    <div class="page-header-left">
        <v-breadcrumbs divider="-" :items="breadcrumbs">
            <template v-slot:item="props">
                <v-breadcrumbs-item :href="props.item.href" :class="[props.item.disabled && 'disabled']">
                    <h3>{{ props.item.text }}</h3>
                </v-breadcrumbs-item>
            </template>
        </v-breadcrumbs>
        <template v-if="breadcrumbs.length == 0">
            <v-breadcrumbs>
                <v-breadcrumbs-item>
                    <h3>{{ routeName }}</h3>
                </v-breadcrumbs-item>
            </v-breadcrumbs>
        </template>
    </div>
    <v-spacer></v-spacer>
    <div class="page-header-right pr-3">
        <v-btn small v-if="$route.meta.importButton && !options.invisibleimportButton" @click="importData" v-shortkey.once="['alt', 'i']" @shortkey="importData" class="mr-3">
            <v-icon color="#2670b0">{{$route.meta.importButtonIcon ? $route.meta.importButtonIcon : 'arrow_upward'}}</v-icon>  {{$route.meta.importButtonText ? $route.meta.importButtonText : 'Nhập file'}}
        </v-btn>
        <v-btn small v-if="$route.meta.exportButton && !options.invisibleexportButton" @click="exportData" v-shortkey.once="['alt', 'e']" @shortkey="exportData" class="mr-3">
            <v-icon color="#2670b0">{{$route.meta.exportButtonIcon ? $route.meta.exportButtonIcon : 'arrow_downward'}}</v-icon>  {{$route.meta.exportButtonText ? $route.meta.exportButtonText : 'Xuất file'}}
        </v-btn>
        <v-btn small v-if="$route.meta.saveButton && !options.invisibleSaveButton" @click="saveData" v-shortkey.once="['ctrl', 's']" @shortkey="saveData" class="mr-3">
            <v-icon color="#2670b0">save</v-icon>  {{$route.meta.saveButtonText ? $route.meta.saveButtonText : 'LƯU LẠI'}}
        </v-btn>
        <v-btn small v-if="$route.meta.createButton && !options.invisibleCreateButton" @click="createData" v-shortkey.once="['alt', 'n']" @shortkey="createData" class="mr-3">
            <v-icon color="#2670b0">{{$route.meta.createButtonIcon ? $route.meta.createButtonIcon : 'add'}}</v-icon>  {{$route.meta.createButtonText ? $route.meta.createButtonText : 'Thêm mới'}}
        </v-btn>
        <v-btn small v-if="$route.meta.refreshButton" @click="refreshData" v-shortkey.once="['alt','f5']" @shortkey="refreshData" class="mr-3">
            <v-icon class="#2670b0">sync</v-icon>
        </v-btn>
    </div>
</v-layout>
</template>

<script>
import menu from "@/api/menu";
import paths from "@/router/paths";
import {
    buildBreadcrumb
} from "@/commons/utils";
export default {
     data() {
        return {
            options: {}
        }
     },
    computed: {
        routeName() {
            var title = this.$route.params.title ? this.$route.params.title : this.$route.meta.title;
            return title ? title : this.$route.name;
        },
        breadcrumbs: function () {
            let breadcrumbs = [];
            let routeName = this.$route.name;
            breadcrumbs = buildBreadcrumb(routeName, this.$route.path, this.$route.params.Pid, this.$route.params.title, menu, paths);
            return breadcrumbs;
        }
    },
    methods: {
        saveData() {
            window.getApp.$emit('PRE_SAVE_DATA');
        },
        createData() {
          this.$root.$emit('REQUEST_CREATE_DATA');
        },
        refreshData() {
          this.$root.$emit('REQUEST_REFRESH_DATA');
        },
        importData() {
          this.$root.$emit('REQUEST_IMPORT_DATA');
        },
        exportData() {
          this.$root.$emit('REQUEST_EXPORT_DATA');
        },
        changeOption(options) {
            this.options = options;
        }
    },
    mounted() {
        this.$root.$on("REQUEST_ROOT_OPTION", this.changeOption);
    }
};
</script>
